<ph-toolbar>
    <ph-status-badge [status]="statusBadgeStatus" variant="light" dot aria-label="Payable status" (click)="statusClicked.emit()">
        {{ payable.statusDescription }}
    </ph-status-badge>
    <ph-tooltip *ngIf="!!errorMessage" [text]="errorMessage" side="top">
        <i class="fa fa-exclamation-circle text-danger" aria-hidden="true"></i>
    </ph-tooltip>
</ph-toolbar>
